module.exports = __webpack_public_path__ + "assets/img/logitech-becomethenextcreator-w960.db3731c7.webp";